import { ApiArtist } from "../../api/dataTypes";
import { utilities } from "../../styles";
import { Uid } from "../../types";
import ArtistLineUpComponent from "../ArtistLineUpComponent";
import styles from "./MainPage.module.css";

function PlayerLineup(props: {
  artistLineup: ApiArtist[];
  boostedArtist: Uid | undefined;
  formattedPointsTotal: string;
  formattedCostTotal: string;
  formattedMoneyTotal: string;
  tradesRemaining: number;
  handleOpenArtistPage: (id: Uid) => void;
  handleDropFromLineup?: (id: Uid) => void | undefined;
  handleArtistBoost?: (id: Uid | undefined) => void | undefined;
  handleSearchOpened: () => void;
}) {
  const {
    artistLineup,
    boostedArtist,
    formattedPointsTotal,
    formattedCostTotal,
    formattedMoneyTotal,
    tradesRemaining,
    handleOpenArtistPage,
    handleDropFromLineup,
    handleArtistBoost,
    handleSearchOpened,
  } = props;
  return (
    <div className={styles["lineup"]}>
      <ArtistLineUpComponent
        artists={artistLineup}
        handleArtistClicked={handleOpenArtistPage}
        handleArtistDropped={handleDropFromLineup}
        handleAddArtist={handleSearchOpened}
        handleArtistBoost={handleArtistBoost}
        boostedArtist={boostedArtist}
      />
      <div style={{ margin: "10px 0 0 0" }}>
        <div
          className={`${styles["lineup-row"]} ${utilities["flex-row"]} ${utilities["space-between"]}`}
        >
          <div>Weekly Lineup Total</div>
          <div
            className={`${utilities["flex-row"]} ${utilities["flex-rhs"]}`}
            style={{ gap: "5px" }}
          >
            <div>{formattedPointsTotal}</div>
            <div>/</div>
            <div>{formattedCostTotal}</div>
          </div>
        </div>
        <div
          className={`${styles["lineup-row"]} ${utilities["flex-row"]} ${utilities["space-between"]}`}
        >
          <div>Available Money</div>
          {/* TODO include a -x or +x value next to the cache'd money value to compare to the player's current money */}
          <div>{formattedMoneyTotal}</div>
        </div>
        <div
          className={`${styles["lineup-row"]} ${utilities["flex-row"]} ${utilities["space-between"]}`}
        >
          <div>Trades Remaining</div>
          <div>{tradesRemaining}</div>
        </div>
      </div>
    </div>
  );
}

export default PlayerLineup;
